import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollRestoration = () => {
    const location = useLocation();

    // Simple scroll restoration that always scrolls to top on location change
    useEffect(() => {
        window.scrollTo(0, 0);
        // Profile and directory scroll inside the layout, not the window.
        document.getElementById('app-scroll-container')?.scrollTo(0, 0);
    }, [location.pathname]);

    return null;
};

export default ScrollRestoration;
